module.exports = __webpack_public_path__ + "img/g6.cbac446c.png";